import React, { Component }     from 'react'
import { connect }              from 'react-redux';
import {
    GetTipoMidiaPost,
    GetComentariosPostTurma,
    GetRemoverComentarioEquipe
}                               from '../../../actions/turmaAction';
import TurmaPostFormComentario  from './turma_post_form_comentario';
import ComentarioPost           from '../../../container/renderComentarioPostTimelineEquipe';
import FotoPerfil               from '../../../container/renderFotoPerfil';
import BtAcaoComentario         from '../../../container/btAcaoRemoverItem';
import TimeLineItem             from '../../../container/renderTimeLineEquipe';

class Turma_Post_Comentario extends Component {

    constructor(props) {

        super(props);
        this.state = {
            load              : false,
            loadComentario    : false,
            buttonDisabledCom : false,
            comentariosPost   : [],
            tur_pos_tipo      : this.props.ItemPostTimeline.tur_pos_tipo,
            tur_pos_midia     : this.props.ItemPostTimeline.tur_pos_midia,
            tur_pos_id        : this.props.ItemPostTimeline.tur_pos_id,
            use_foto          : this.props.ItemPostTimeline.use_foto,
            use_nome          : this.props.ItemPostTimeline.use_nome,
            created_at        : this.props.ItemPostTimeline.created_at,
            tur_pos_post      : this.props.ItemPostTimeline.tur_pos_post,
            num_like          : this.props.ItemPostTimeline.num_like
        }
  
    }

    componentWillMount(){
      this.props.GetComentariosPostTurma(this.props.ItemPostTimeline.tur_pos_id);
    }

    exclusaoComentarioPost(elem){
      this.props.GetRemoverComentarioEquipe(this.props.session.id,elem);
    }

    getComentariosPost(){
     
            if (this.props.comentarios) {
                const dados = this.props.comentarios;
               
                return dados.map((elem, i) => {

                    return <ComentarioPost
                            id         = {elem.tur_com_pos_id}
                            foto       = {elem.use_foto}
                            nome       = {elem.use_nome}
                            key        = {i}
                            funcao     = {<BtAcaoComentario funcao={this.exclusaoComentarioPost.bind(this,elem)}/>}
                            use_id     = {this.props.session.id}
                            use_id_com = {elem.tur_com_pos_cod_usuario}
                            coment     = {elem.tur_com_pos_comentario}
                            />;
                    });

                }else{
                    return "";
                }
    }

    render() {
    
       const formComent = <div className="media-raking">
                                <div className="media-left">
                                    <FotoPerfil width="32" height="30" className="media-object img-rounded" src={this.props.session.foto} />
                                </div>
                                <div className="media-body">
                                    <TurmaPostFormComentario tur_pos_id={this.state.tur_pos_id} use_id={this.props.session.id} />
                                </div>
                            </div>;

      //  const comentarios = (this.state.loadComentario ? this.state.comentariosPost : "");
        //const btAcao      = <span>{formComent} <div id="comentarios">{this.state.comentariosPost}</div></span>;
        const btAcao      = <span> { formComent } <div id="comentarios"> { this.props.comentarios ? this.getComentariosPost() : "" } </div> </span>;

        return (
            <div>
                <ul className="timeline bottom-zero">
                  <TimeLineItem
                        id           = {this.state.tur_pos_id}
                        foto         = {this.state.use_foto}
                        nome         = {this.state.use_nome}
                        dataCriado   = {this.state.created_at}
                        postConteudo = {this.state.tur_pos_post}
                        midia        = {this.state.tur_pos_midia}
                        tipo         = {this.state.tur_pos_tipo}
                        postMidia    = {<div dangerouslySetInnerHTML={{__html: this.props.GetTipoMidiaPost(this.props.ItemPostTimeline)}} />}
                        footerPost   = { btAcao }
                    />
               </ul>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        session     : state.auth.session,
        comentarios : state.turmaReducer.allComentPost

    }
}

export default connect(mapStateToProps, { GetTipoMidiaPost, GetRemoverComentarioEquipe, GetComentariosPostTurma })(Turma_Post_Comentario);



// WEBPACK FOOTER //
// ./src/components/professor/timeline_turma/turma_post_comentario.js